// import { useCallback } from 'react'
// import { useSelector } from 'react-redux'

import { TextIcon } from '../../Icons/Icons'
import STButton from '../ScrollToolbar/STButton'

const TextButton = (props) => {
  return (
    <STButton
      tooltip={'Guardar'}
      tooltipEnabled
      {...props}
      icon={<TextIcon />}
    />
  )
}
export default TextButton
